import Icon from 'veui/components/Icon'
import { IconIndent } from 'dls-icons-vue'

Icon.register('indent', IconIndent)
